import React from "react";
import { useState, useEffect } from "react";
import "./css/carrusel.css";
import btnLeft from "../../resources/img/carrusel/btn-left.svg";
import btnRight from "../../resources/img/carrusel/btn-right.svg";
import PropTypes from "prop-types";

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
};

const Carrusel = ({
  books = []
}) => {
  const isMobile = useIsMobile();
  const chunkSize = isMobile ? 1 : 3;
  const chunkedBooks = [];
  for (let i = 0; i < books.length; i += chunkSize) {
    chunkedBooks.push(books.slice(i, i + chunkSize));
  }

  return (
    <div
      id="booksCarousel"
      className="carousel slide my-5"
      data-bs-ride="carousel"
      data-bs-interval="3000"
    >
      <div className="carousel-inner">
        {chunkedBooks.map((group, index) => (
          <div
            key={index}
            className={`carousel-item ${index === 0 ? "active" : ""}`}
          >
            <div className="d-flex justify-content-center flex-wrap gap-3 gap-md-4 py-3">
              {group.map((book) => (
                <div
                  key={book.id}
                  className="card shadow border-0 card-style"
                >
                  <div className="row g-0 flex-column flex-md-row">
                    <div className="col-12 col-md-6 d-flex justify-content-center p-2">
                      <img
                        src={book.img}
                        className="rounded-start book-img img-fluid"
                        alt={book.title}
                        onContextMenu={(e) => e.preventDefault()}
                      />
                    </div>

                    <div className="col-12 col-md-6 d-flex flex-column  p-3">
                      <p className="text-barlow-bold-w-hv text-center text-md-start balance-text">
                        {book.title}
                      </p>
                      <p className="mb-0 text-barlow-regular-w-hv text-center text-md-start ">
                        {book.publisher}
                      </p>
                      <p className="mb-1 text-barlow-regular-w-hv text-center text-md-start">
                        {book.country}
                      </p>
                      <p className="mb-0 text-barlow-regular-small-w-hv text-center text-md-start">
                        {book.year}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Controles */}
      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#booksCarousel"
        data-bs-slide="prev"
      >
        <img
          src={btnLeft}
          alt="prev"
          width="24"
          height="48"
          className="d-block "
        />
      </button>

      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#booksCarousel"
        data-bs-slide="next"
      >
        <img
          src={btnRight}
          alt="next"
          width="24"
          height="48"
          className="d-block"
        />
      </button>
    </div>
  );
};

Carrusel.propTypes = {
  books: PropTypes.any,

};

export default Carrusel;
